import requestMaker from 'lib';

export const fetchPublicFeatureConfig = postData => {
  const baseQuery = `/proxy/pbl/cfg/fpfc`;
  const params = {};
  const payload = { ...postData };
  return requestMaker(baseQuery, { params, payload });
};
